import React from 'react'
import PropTypes from 'prop-types'
import SvgIcon from '../../svgIcon'
import styles from './iconButton.css'

const IconButton = ({ tooltip, icon, onClick, disabled, size }) => {
  const sizeInlineStyle = {
    height: `${size}`,
    width: `${size}`
  }
  return (
    <button
      title={tooltip}
      className={styles.button}
      disabled={disabled}
      onClick={onClick}
    >
      <SvgIcon icon={icon} className={styles.icon} style={sizeInlineStyle} />
    </button>
  )
}

IconButton.propTypes = {
  icon: PropTypes.string,
  tooltip: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  size: PropTypes.string
}

IconButton.defaultProps = {
  size: '1rem',
  tooltip: ''
}

export default IconButton



// WEBPACK FOOTER //
// ./src/components/buttons/iconButton/iconButton.jsx